<div class="item-list" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
    @for (item of ngModel; track index; let index = $index) {
    <div #itemDivs class="item" draggable="true" (dragstart)="onDragStart($event, index)" (dragenter)="onDragEnter($event, index)" (dragend)="onDragEnd($event)"[class.dragging]="dragIndex === index">
      <p-inputGroup>
        <span class="drag-handle" (mousedown)="dragHandleClicked=true" (mouseup)="dragHandleClicked=false">
          <i class="fas fa-grip-vertical"></i>
        </span>
        <input type="text" [(ngModel)]="ngModel[$index]" pInputText (ngModelChange)="emitChange()" (keypress)="keyPressed($event)">
        <button type="button" pButton tabindex="-1" class="delete-button" icon="fas fa-trash" (click)="removeItem($index)">
        </button>
      </p-inputGroup>
    </div>
    }
</div>
<p-button icon="fas fa-plus" [label]="addTitle" (click)="addItem()">
</p-button>
